import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UmpirePublicationCategory} from '@tisa-group/models';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class PublicationCategoryService
  implements CrudService<UmpirePublicationCategory>
{
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpirePublicationCategory[]>> {
    return this.http
      .get(`/publication_categories`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/publication_categories/${id}`, {
      params: objectToHttpParams(params),
    });
  }

  create(
    body: Partial<UmpirePublicationCategory>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePublicationCategory>> {
    return this.http
      .post<JsonApiResponse<UmpirePublicationCategory>>(
        '/publication_categories',
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpirePublicationCategory>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePublicationCategory>> {
    return this.http
      .patch<JsonApiResponse<UmpirePublicationCategory>>(
        `/publication_categories/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePublicationCategory>> {
    return this.http
      .get(`/publication_categories/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
